module Components.Blob

open Fable.Core.JsInterop
open Fable.Import.Browser

let createBlobURL content mimeType =
    let parts = new ResizeArray<obj>([| content |])
    let options = jsOptions<BlobPropertyBag>(fun option -> option.``type`` <- Some mimeType)
    URL?createObjectURL(Blob.Create(parts, options)) |> string
